import React, { useState, useEffect } from 'react';

import { IVideoPlayer } from './interface';
import { useNavigationHistory } from '../../../../../../providers/NavigationHistoryProvider';

const VideoPlayer = ({ url }: IVideoPlayer) => {
  const [isMuted, setIsMuted] = useState(true);

  const { history } = useNavigationHistory();

  useEffect(() => {
    setIsMuted(history.length < 2);
  }, [history.length]);

  return (
    <video
      style={{ maxWidth: '100%', height: 'auto' }}
      autoPlay
      muted={isMuted}
      controls
    >
      <source src={url} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
